import { render, staticRenderFns } from "./PublisherRoles.vue?vue&type=template&id=23977ff2"
import script from "./PublisherRoles.vue?vue&type=script&lang=js"
export * from "./PublisherRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports